import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Project } from '../dto/project';
import { CrudService } from '@mango/core';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ProjectService extends CrudService<Project> {

    constructor(injector: Injector) { super(Project, injector); }

    orderBevestigingGenereren(project: Project) {
        let query: string = `api/dto/project/OrderbevestigingGenereren?projectId=${project.id}`;

        return this.http.post(query, null).pipe(map(x => x as OrderbevestigingResponse));

    }

}

export class OrderbevestigingResponse {
    successful: boolean;
}
